<template>
    <!-- One Forge tool on its own page (Keelan, 2 Nov 2026: "every Forge tool also on its own page").
         Shown only to people who can use the Forge (app Admin/Editor, as on the Forge page) AND that
         tool (ForgeTeam's own Team Hub rules, see ai/forgeAccess.ts). Opens ForgeTeam as a pop-up. -->
    <button v-if="allowed" type="button" class="ai-btn fpb" :title="label" @click="open = true">
        <svg aria-hidden="true" viewBox="0 0 24 24" fill="currentColor"><path d="M13 0L3.5 14H10l-1.5 10L20 9h-6.5L15 0h-2z"/></svg><span>{{ label }}</span>
    </button>
    <forge-team v-if="open" modal :only="kinds" :start-kind="startKind || kinds[0]" :preset-team="presetTeam || ''" :preset-quarter="presetQuarter" @applied="$emit('applied')" @close="open = false" />
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import ForgeTeam from '@/components/ForgeTeam.vue';
import { canUseForgeTool } from '@/ai/forgeAccess';

export default defineComponent({
    name: 'ForgePageButton',
    components: { ForgeTeam },
    // kinds: the ForgeTeam tool keys this button offers (first one opens unless startKind is set)
    props: { kinds: { type: Array as () => string[], required: true }, label: { type: String, required: true }, startKind: String, presetTeam: String, presetQuarter: String },
    emits: ['applied'],
    data() {
        return { open: false };
    },
    computed: {
        allowed(): boolean {
            const user = this.$store.state.user || {};
            return this.kinds.some(kind => canUseForgeTool(user, kind));
        }
    }
});
</script>

<style scoped>
.fpb { display: inline-flex; align-items: center; gap: 6px; padding: 7px 14px; font-size: 13px; border-radius: 8px; white-space: nowrap; border: none; font-family: inherit; cursor: pointer; }
.fpb svg { width: 13px; height: 13px; flex-shrink: 0; }
</style>
